var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.type === "textarea"
    ? _c(
        "div",
        { staticClass: "c-rect-input" },
        [
          _c(
            "label",
            {
              staticClass:
                "c-rect-input__textarea-label--before-invisible-textarea",
              attrs: {
                for: _vm.inputId,
                "data-required-suffix": this.requiredSuffix
              }
            },
            [_vm._v(_vm._s(_vm.label))]
          ),
          _vm._v(" "),
          _c("textarea", {
            directives: [
              {
                name: "model",
                rawName: "v-model.lazy",
                value: _vm.value,
                expression: "value",
                modifiers: { lazy: true }
              }
            ],
            ref: "invisibleTextarea",
            staticClass: "c-rect-input__invisible-textarea",
            attrs: {
              name: _vm.name,
              required: _vm.required ? true : false,
              maxlength: _vm.maxlength
            },
            domProps: { value: _vm.value },
            on: {
              change: function($event) {
                _vm.value = $event.target.value
              }
            }
          }),
          _vm._v(" "),
          _c("vue-editor", {
            staticClass: "s-text s-text--vue",
            attrs: { id: _vm.inputId, editorToolbar: _vm.customToolbar },
            model: {
              value: _vm.value,
              callback: function($$v) {
                _vm.value = $$v
              },
              expression: "value"
            }
          }),
          _vm._v(" "),
          _vm.maxlength
            ? _c(
                "span",
                {
                  staticClass: "c-rect-input__note",
                  style: _vm.remainingLengthStyle
                },
                [_vm._v(_vm._s(_vm.remainingLengthText))]
              )
            : _vm._e()
        ],
        1
      )
    : _vm.type === "checkbox"
    ? _c("div", { staticClass: "c-checkbox" }, [
        _c(
          "input",
          _vm._b(
            {
              ref: "boolvalue",
              staticClass: "c-checkbox__input",
              attrs: {
                type: "checkbox",
                name: _vm.name,
                id: _vm.inputId,
                disabled: _vm.disabled
              },
              domProps: { checked: _vm.checked },
              on: { click: _vm.checkboxClicked, input: _vm.input }
            },
            "input",
            _vm.$attrs,
            false
          )
        ),
        _vm._v(" "),
        _c(
          "label",
          {
            staticClass: "c-checkbox__label",
            attrs: {
              for: _vm.inputId,
              "data-required-suffix": this.requiredSuffix
            }
          },
          [_vm._v(_vm._s(_vm.label))]
        )
      ])
    : _c("div", { class: "c-rect-input " + _vm.cssClasses }, [
        _vm.type === "checkbox"
          ? _c(
              "input",
              _vm._b(
                {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.dataValue,
                      expression: "dataValue"
                    }
                  ],
                  ref: "textvalue",
                  staticClass: "c-rect-input__input",
                  class: { "has-value": this.hasValue },
                  attrs: {
                    id: _vm.inputId,
                    disabled: _vm.disabled,
                    required: _vm.required,
                    name: _vm.name,
                    maxlength: _vm.maxlength,
                    noDecimal: _vm.noDecimal,
                    textInputShouldBehaveAsNumber:
                      _vm.textInputShouldBehaveAsNumber,
                    type: "checkbox"
                  },
                  domProps: {
                    checked: Array.isArray(_vm.dataValue)
                      ? _vm._i(_vm.dataValue, null) > -1
                      : _vm.dataValue
                  },
                  on: {
                    input: _vm.input,
                    keydown: _vm.keyhandler,
                    change: function($event) {
                      var $$a = _vm.dataValue,
                        $$el = $event.target,
                        $$c = $$el.checked ? true : false
                      if (Array.isArray($$a)) {
                        var $$v = null,
                          $$i = _vm._i($$a, $$v)
                        if ($$el.checked) {
                          $$i < 0 && (_vm.dataValue = $$a.concat([$$v]))
                        } else {
                          $$i > -1 &&
                            (_vm.dataValue = $$a
                              .slice(0, $$i)
                              .concat($$a.slice($$i + 1)))
                        }
                      } else {
                        _vm.dataValue = $$c
                      }
                    }
                  }
                },
                "input",
                _vm.$attrs,
                false
              )
            )
          : _vm.type === "radio"
          ? _c(
              "input",
              _vm._b(
                {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.dataValue,
                      expression: "dataValue"
                    }
                  ],
                  ref: "textvalue",
                  staticClass: "c-rect-input__input",
                  class: { "has-value": this.hasValue },
                  attrs: {
                    id: _vm.inputId,
                    disabled: _vm.disabled,
                    required: _vm.required,
                    name: _vm.name,
                    maxlength: _vm.maxlength,
                    noDecimal: _vm.noDecimal,
                    textInputShouldBehaveAsNumber:
                      _vm.textInputShouldBehaveAsNumber,
                    type: "radio"
                  },
                  domProps: { checked: _vm._q(_vm.dataValue, null) },
                  on: {
                    input: _vm.input,
                    keydown: _vm.keyhandler,
                    change: function($event) {
                      _vm.dataValue = null
                    }
                  }
                },
                "input",
                _vm.$attrs,
                false
              )
            )
          : _c(
              "input",
              _vm._b(
                {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.dataValue,
                      expression: "dataValue"
                    }
                  ],
                  ref: "textvalue",
                  staticClass: "c-rect-input__input",
                  class: { "has-value": this.hasValue },
                  attrs: {
                    id: _vm.inputId,
                    disabled: _vm.disabled,
                    required: _vm.required,
                    name: _vm.name,
                    maxlength: _vm.maxlength,
                    noDecimal: _vm.noDecimal,
                    textInputShouldBehaveAsNumber:
                      _vm.textInputShouldBehaveAsNumber,
                    type: _vm.type
                  },
                  domProps: { value: _vm.dataValue },
                  on: {
                    input: [
                      function($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.dataValue = $event.target.value
                      },
                      _vm.input
                    ],
                    keydown: _vm.keyhandler
                  }
                },
                "input",
                _vm.$attrs,
                false
              )
            ),
        _vm._v(" "),
        _c(
          "label",
          {
            staticClass: "c-rect-input__label",
            attrs: {
              for: _vm.inputId,
              "data-required-suffix": this.requiredSuffix
            }
          },
          [_vm._v(_vm._s(_vm.label))]
        ),
        _vm._v(" "),
        _vm.maxlength
          ? _c("span", { staticClass: "c-rect-input__note" }, [
              _vm._v(_vm._s(_vm.remainingLengthText))
            ])
          : _vm._e()
      ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }